var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZapPostReel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 75,
    viewBox: "0 0 70 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_4294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4558 17.9746V44.9366",
    stroke: "url(#paint0_linear_7338_4294)",
    strokeWidth: 3.5443,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9746 31.4561H44.9366",
    stroke: "url(#paint1_linear_7338_4294)",
    strokeWidth: 3.5443,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1835 60.6648H15.7278C8.2825 60.6648 2.24683 54.6293 2.24683 47.1838V15.7281C2.24683 8.28275 8.2825 2.24707 15.7278 2.24707H47.1835C54.6291 2.24707 60.6646 8.28275 60.6646 15.7281V22.6964",
    stroke: "url(#paint2_linear_7338_4294)",
    strokeWidth: 3.5443,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.4358 54.699L55.74 31.8088C55.9808 31.3213 56.4774 31.0127 57.0211 31.0127H67.4475C68.5643 31.0127 69.2494 32.2365 68.6654 33.1886L60.6716 46.2216C60.0877 47.1737 60.7728 48.3975 61.8896 48.3975H66.9698C68.1777 48.3975 68.8407 49.8034 68.0721 50.7354L49.2619 73.5459C48.2238 74.8047 46.2265 73.6203 46.8332 72.1056L52.1943 58.7206C52.5702 57.7819 51.879 56.7605 50.8679 56.7605H45.7169C44.6578 56.7605 43.9668 55.6486 44.4358 54.699Z",
    fill: "url(#paint3_linear_7338_4294)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7338_4294",
    x1: 31.9558,
    y1: 17.9746,
    x2: 31.9558,
    y2: 44.9366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#803AEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475962,
    stopColor: "#EA489A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA8F3E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7338_4294",
    x1: 31.5,
    y1: 29,
    x2: 31.5,
    y2: 33.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE46A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED5787"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7338_4294",
    x1: 31.4557,
    y1: 2.24707,
    x2: 31.4557,
    y2: 60.6648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#803AEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475962,
    stopColor: "#EA489A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA8F3E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7338_4294",
    x1: 60.7388,
    y1: 31.0127,
    x2: 46.8057,
    y2: 80.5947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD3790"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#248ECC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_4294"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62.9114,
    height: 62.9114,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZapPostReel);
export default __webpack_public_path__ + "static/media/zap-post-reel.4fb31feb13b4eea1d56728d133ba7438.svg";
export { ForwardRef as ReactComponent };